export default __webpack_public_path__ + "static/media/1708.9c165e14.png";